var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalianFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.27,
    height: 18.27,
    viewBox: "0 0 18.27 18.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_836",
    "data-name": "Ellipse 836",
    cx: 9.135,
    cy: 9.135,
    r: 9.135,
    transform: "translate(864.365 605)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25727",
    "data-name": "Mask Group 25727",
    transform: "translate(-864.365 -605)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22101",
    "data-name": "Rectangle 22101",
    width: 7,
    height: 19,
    transform: "translate(863 605)",
    fill: "#169246"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22102",
    "data-name": "Rectangle 22102",
    width: 7,
    height: 19,
    transform: "translate(870 605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22103",
    "data-name": "Rectangle 22103",
    width: 7,
    height: 19,
    transform: "translate(877 605)",
    fill: "#ce2b37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalianFlag);
export default __webpack_public_path__ + "static/media/italian_flag.e9ca9b5ceae396864451661c5a1af53b.svg";
export { ForwardRef as ReactComponent };